<template>
  <div class="flex items-center justify-center mobile:gap-1 laptop:gap-2">
    <div class="font-roboto font-medium mobile:text-sm mobile:hidden laptop:hidden laptop:text-base desktop:block text-gray-900">
      Go Live
    </div>
    <!-- Moves at once on click (colour, knob and label together); goes back if the API call fails -->
    <button type="button" role="switch" :aria-checked="localOnline" :disabled="saving"
      class="relative w-[84px] h-[38px] rounded-full flex-shrink-0 transition-[background-color,opacity] duration-300 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-green-300 disabled:cursor-wait"
      :class="[localOnline ? 'bg-green-500' : 'bg-[#EFEFEF]', saving ? 'opacity-70' : '']"
      @click="toggle">
      <span class="absolute inset-y-0 left-[10px] flex items-center text-[14px] font-roboto font-medium text-white transition-opacity duration-200"
        :class="localOnline ? 'opacity-100 delay-100' : 'opacity-0'">Online</span>
      <span class="absolute inset-y-0 right-[10px] flex items-center text-[14px] font-roboto font-medium text-gray-600 transition-opacity duration-200"
        :class="localOnline ? 'opacity-0' : 'opacity-100 delay-100'">Offline</span>
      <span class="absolute top-[7px] left-[6px] w-6 h-6 rounded-full shadow-[0px_1px_4px_0px_#00000033] flex items-center justify-center transition-[transform,background-color] duration-300 ease-out"
        :class="localOnline ? 'translate-x-[48px] bg-white' : 'translate-x-0 bg-gray-600'">
        <span class="w-2 h-2 rounded-full transition-colors duration-300" :class="localOnline ? 'bg-green-500' : 'bg-white'" />
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: ['user'],
  emits: ['toggle'],
  data() {
    return {
      localOnline: false,
      saving: false,
    }
  },

  computed: {
    isOnline() {
      return this.user?.user?.active == '1'
    }
  },

  watch: {
    isOnline: {
      handler(value) {
        if (!this.saving) this.localOnline = value
      },
      immediate: true,
    },
  },

  methods: {
    toggle() {
      if (this.saving) return
      const next = !this.localOnline
      this.localOnline = next
      this.saving = true
      // parent saves it and calls back with success / failure
      this.$emit('toggle', next, (ok) => {
        this.saving = false
        if (!ok) this.localOnline = this.isOnline
      })
    }
  }
}
</script>
